import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all forms
export const getForms = async (filters = {}) => {
  try {
    const normalizedFilters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== undefined),
    );

    const response = await axiosInstance.get(`${API_URL}/forms`, {
      params: normalizedFilters,
      paramsSerializer: {
        serialize: (params) => {
          const searchParams = new URLSearchParams();

          Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((entry) => {
                searchParams.append(key, String(entry));
              });
              return;
            }

            searchParams.append(key, String(value));
          });

          return searchParams.toString();
        },
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching forms:", error.response?.data || error);
    throw error;
  }
};

// GET forms enabled for app action button
export const getAppForms = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-assignments/app`);
    return response.data;
  } catch (error) {
    console.error("Error fetching app forms:", error.response?.data || error);
    throw error;
  }
};

// GET a single form
export const getFormById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/forms/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new form
export const createForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/forms`, formData);
    return response.data;
  } catch (error) {
    console.error("Error creating form:", error.response?.data || error);
    throw error;
  }
};

// COPY an existing form
export const copyForm = async (id) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/forms/${id}/copy`);
    return response.data;
  } catch (error) {
    console.error("Error copying form:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing form
export const updateForm = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/forms/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error("Error updating form:", error.response?.data || error);
    throw error;
  }
};

// DELETE a form
export const deleteForm = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/forms/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting form:", error.response?.data || error);
    throw error;
  }
};
